import { Routes, RouterModule } from '@angular/router';
import { SetupAccountComponent } from './setup-account/setup-account.component';
import { SignupAccountTypeComponent } from './account-type/signup-account-type.component';
import { SetupBillingComponent } from './setup-billing/setup-billing.component';

const SignupRoutes: Routes = [
  {
    path: 'setup/billing/:org_id',
    component: SetupBillingComponent,
  },
  {
    path: 'setup/:account_type/:org_id',
    component: SetupAccountComponent,
  },
  {
    path: 'signup',
    component: SignupAccountTypeComponent,
    children: [
      {
        path: '',
        component: SignupAccountTypeComponent,
      },
    ],
  },
];

export const SignupRouting = RouterModule.forChild(SignupRoutes);
